import ShippingOptionsCustomerTable, {
  CrmReceiverCustomer,
} from '../ShippingOptionsCustomerTable';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import CrmCustomerListFilter, {
  CrmFilterFormValues,
} from '../CustomerListFilter';
import { Button, Col, Divider, Form, Row } from 'antd';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import { DateTimeFormat } from '@/utils/moment';
import {
  CrmCustomerListProps,
  CrmCustomerListResponse,
  CrmSurveySatisfaction,
} from '@/core/domain/crm/CrmList/CrmList.types';
import { SendOptionType } from '@/core/domain/crm/SendOptions/SendOptions.types';
import { useQueryParams } from '@/hooks/useQueryParams';
import { queryHooks } from './queryHooks';
import { useWindowSize } from '@/hooks';
import moment from 'moment';

const hasFilterDate = [
  SendOptionType.birthdays,
  SendOptionType.satisfactionSurvey,
  SendOptionType.futureServices,
  SendOptionType.clientWithoutMovement,
];

const CrmCustomersList: React.FC<CrmCustomerListProps> = ({
  onPrev,
  CustomersSelected,
  onCustomersSelected,
  customerIds,
}) => {
  const [dataSource, setDataSource] = useState<CrmReceiverCustomer[]>([]);
  const [filter, setFilter] = useState<CrmFilterFormValues>();
  const { type } = useQueryParams<{ type?: SendOptionType }>();
  const { isMobile } = useWindowSize();

  const form = Form.useFormInstance();

  const queryHook = type ? queryHooks[type] : () => null;

  const formatFilterDate = (date?: moment.Moment, type?: SendOptionType) => {
    if (!date || !type || !hasFilterDate.includes(type)) return undefined;

    return type === SendOptionType.clientWithoutMovement
      ? date.format('YYYY-MM-DD')
      : date.format(DateTimeFormat);
  };

  const queryReturn = queryHook({
    ...filter,

    initialDate: formatFilterDate(filter?.initialDate, type),
    finalDate: formatFilterDate(filter?.finalDate, type),

    // Recovery Debts
    dueDateInitial:
      type === SendOptionType.recoveryOfDebts
        ? filter?.dueDateInitial?.format(DateTimeFormat)
        : undefined,
    dueDateFinal:
      type === SendOptionType.recoveryOfDebts
        ? filter?.dueDateFinal?.format(DateTimeFormat)
        : undefined,

    // Without Moviment
    monthStart: undefined,
    monthEnd: undefined,
  });

  const items = flatInfiniteData(queryReturn?.data);

  useEffect(() => {
    if (items) {
      const surveyMap = (item: CrmSurveySatisfaction) => ({
        id: item.customer.id,
        customer: {
          id: item?.customer.id,
          name: item?.customer.name,
          email:
            CustomersSelected.find(({ id }) => id === item.customer.id)
              ?.customer.email || item?.customer.email,
          date: moment(item?.customer.birthDate).format(DateTimeFormat),
          lastSentEmail: moment(item?.customer.lastSentEmail).format(
            DateTimeFormat,
          ),
          vehicle: item.vehicle,
        },
      });

      const commonMap = (item: CrmCustomerListResponse) => ({
        id: item.id,
        customer: {
          id: item?.id,
          name: item?.name,
          email:
            CustomersSelected.find(({ id }) => id === item.id)?.customer
              .email || item?.email,
          date: item?.birthDate,
          lastSentEmail: item?.lastSentEmail,
        },
      });

      const customersData =
        type === SendOptionType.satisfactionSurvey
          ? items.map(surveyMap)
          : items.map(commonMap);

      setDataSource(customersData);

      form.setFieldValue('customers', customersData);
    }
  }, [queryReturn?.dataUpdatedAt]);

  return (
    <>
      <CrmCustomerListFilter onFilter={setFilter} />

      <Divider />

      <ShippingOptionsCustomerTable
        dataSource={dataSource}
        loading={queryReturn?.isLoading}
        CustomersSelected={CustomersSelected}
        onCustomersSelected={onCustomersSelected}
        customerIds={customerIds}
        refetch={queryReturn?.refetch}
        fetchNextPage={queryReturn?.fetchNextPage}
        hasNextPage={queryReturn?.hasNextPage}
        isFetching={queryReturn?.isFetching}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" block>
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />
            <span>Continuar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CrmCustomersList;
